import React from 'react'
import ReactDOM from 'react-dom'
import { ThemeProvider } from 'styled-components'
import 'antd/dist/antd.css'
import './index.css'
import './styles/_override.css'
import App from './app'
import { theme } from './styles/_variables'

// console.log('env: ', process.env)

ReactDOM.render(<ThemeProvider theme={theme}><App /></ThemeProvider>, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js